// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__BGz5s","list":"BalanceDue_list__1DAOg","listRow":"BalanceDue_listRow__15ouT","total":"BalanceDue_total__2mUxn"};